export const SCREENPLAY_BACKGROUND_STORAGE_KEY = "tableread.screenplayBackground";
export const SCREENPLAY_SPELLCHECK_STORAGE_KEY = "tableread.screenplaySpellcheck";
export const parseScreenplaySpellcheck = (value: unknown) => value !== "false" && value !== false;
export type ScreenplayBackground = "dark" | "white";
export const DEFAULT_SCREENPLAY_BACKGROUND: ScreenplayBackground = "dark";

export const parseScreenplayBackground = (value: unknown): ScreenplayBackground =>
  value === "white" ? "white" : DEFAULT_SCREENPLAY_BACKGROUND;
